import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import reportWebVitals from './reportWebVitals';

const appVersion = appversion.version;

const root = ReactDOM.createRoot(document.getElementById('root'));

let host = window.location.host.toLowerCase();
const hostname = window.location.hostname.toLowerCase();
let pathname = window.location.pathname.toLowerCase();

if (pathname === "/join-our-team") {
  pathname = pathname + "/";
}

if (pathname === "/join-our-team/") {
  let joinourteamSearchURL;
  if (hostname === "localhost") {
    joinourteamSearchURL = "https://" + host+ pathname + "search";
  }
  else {
    joinourteamSearchURL = "https://" + host+ pathname + "search";
  }
  window.location.href = joinourteamSearchURL;
}

root.render(
  <React.StrictMode>    
    <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
      >
        <App />
      </CacheBuster>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
